import { Component, ElementRef, Inject, InjectionToken, OnInit, ViewChild } from '@angular/core';
import { IInjectedElementDtype } from '../../../models/InjectedElementDtype';
import { Indicators, IndicatorsColor, IndicatorsIcon } from '../../../models/indicators';
import { ITableColumnIndicator } from '../../../models/table';
import { ITableColumnTags } from '../../../models/table';

import { SessionService } from '../../../services/session.service';

import { SHARED_MODULES } from '../../../../shared.';
import { GetLinkPipe } from '../../../pipes/get-link.pipe';
import { FilterByPipe } from '../../../pipes/filter-by.pipe';
import { LinkTypePipe } from '../../../pipes/link-type.pipe';
import { SanitizerPipe } from '../../../pipes/sanitizer.pipe';
import { ColorTagsDirective } from '../../../directives/color-tags.directive';
import { PhTooltipDirective } from '../../../directives/ph-tooltip.directive';
import { PhIconComponent } from '../../ph-icon/ph-icon.component';

export const ELEMENT = new InjectionToken<any>('element', {
	providedIn: 'root',
	factory: () => 'element'
});

export type LinkDtypeElement<T> = {
	dtype: 'link';
	image_tooltip?: string;
	indicators: Array<ITableColumnIndicator>;
	links: Array<T>;
	mtype: string;
	tags?: ITableColumnTags;
	target: '_blank' | '_self';
	value: string;
}

@Component({
    selector: 'app-link-dtype',
    templateUrl: 'link-dtype.component.html',
    styleUrls: ['link-dtype.component.scss'],
	imports: [
		SHARED_MODULES,
		FilterByPipe,
		GetLinkPipe,
		LinkTypePipe,
		SanitizerPipe,
		ColorTagsDirective,
		PhTooltipDirective,
		PhIconComponent
	],
    standalone: true
})
export class LinkDtypeComponent implements OnInit {

	public element: LinkDtypeElement<any>;
	public indicators: Array<{ icon: string, color: string, tooltip: string }> = [];
	public isLinksMenu: boolean = false;
	public isTooltip: boolean = false;

	@ViewChild('inputElement') inputElement: ElementRef;

	constructor(
		@Inject(ELEMENT) private elementInjected:  IInjectedElementDtype<LinkDtypeElement<any>>,
		private sessionService: SessionService
	) {}

	ngOnInit(): void {
		this.element = this.elementInjected.element;

		if (this.sessionService.hasAccess('ph-planogram-edit')) {
			this.element.indicators.forEach((indicator: ITableColumnIndicator) => {
				if (indicator.type == 'WARNING' && !this.sessionService.personalSettings.warningIndicators) return;
				if (indicator.type == 'ERROR' && !this.sessionService.personalSettings.errorIndicators) return;

				this.indicators.push({
					icon: IndicatorsIcon[indicator.type],
					color: IndicatorsColor[indicator.type],
					tooltip: Indicators[indicator.name] || indicator.name
				})
			});
		}
		else if (this.sessionService.defaults.isManager) {
			this.element.indicators
				.filter((indicator: ITableColumnIndicator): boolean => indicator.type === 'SCHEDULED')
				.forEach((indicator: ITableColumnIndicator): void => {
					this.indicators.push({
						icon: IndicatorsIcon[indicator.type],
						color: IndicatorsColor[indicator.type],
						tooltip: Indicators[indicator.name] || indicator.name
					});
				});
		}

		this.isLinksMenu = this.element.links.length > 1;
		this.isTooltip = this.elementInjected.isTooltip;
	}

	openLinksMenu(): void {
		this.inputElement.nativeElement.focus();
	}
}
